import { isObject } from "lodash";
import { useState } from "react";

const useResolvePromise = (promise) => {
  const [promiseLoading, updateLoading] = useState(true);
  const [promiseData, updateData] = useState(null);
  const [promiseError, updateError] = useState(null);

  promise
    .then(
      (result) => {
        if (isObject(result) && result.data) {
          result = Object.values(result.data)[0];
        }
        updateData(result);
      },
      (error) => updateError(error),
    )
    .then(() => {
      updateLoading(false);
    });

  return {
    loading: promiseLoading,
    data: promiseData,
    error: promiseError,
  };
};

export default useResolvePromise;
